module.exports = __webpack_public_path__ + "img/748.6746fe0f.png";